import {
    FETCH_FAQS_REQUEST,
    FETCH_FAQS_SUCCESS,
    FETCH_FAQS_FAILURE,
    CREATE_FAQ_REQUEST,
    CREATE_FAQ_SUCCESS,
    CREATE_FAQ_FAILURE,
    UPDATE_FAQ_REQUEST,
    UPDATE_FAQ_SUCCESS,
    UPDATE_FAQ_FAILURE,
    ARCHIVE_FAQ_REQUEST,
    ARCHIVE_FAQ_SUCCESS,
    ARCHIVE_FAQ_FAILURE,
  } from "./types";
  
  import {
    createFAQ,
    fetchFAQs,
    updateFAQ,
    archiveFAQ,
  } from "../../services/faqService";
  
  // Action Creators
  export const fetchFAQsRequest = () => ({ type: FETCH_FAQS_REQUEST });
  export const fetchFAQsSuccess = (faqs) => ({
    type: FETCH_FAQS_SUCCESS,
    payload: faqs,
  });
  export const fetchFAQsFailure = (error) => ({
    type: FETCH_FAQS_FAILURE,
    payload: error,
  });
  
  export const createFAQRequest = () => ({ type: CREATE_FAQ_REQUEST });
  export const createFAQSuccess = (faq) => ({
    type: CREATE_FAQ_SUCCESS,
    payload: faq,
  });
  export const createFAQFailure = (error) => ({
    type: CREATE_FAQ_FAILURE,
    payload: error,
  });
  
  export const updateFAQRequest = () => ({ type: UPDATE_FAQ_REQUEST });
  export const updateFAQSuccess = (faq) => ({
    type: UPDATE_FAQ_SUCCESS,
    payload: faq,
  });
  export const updateFAQFailure = (error) => ({
    type: UPDATE_FAQ_FAILURE,
    payload: error,
  });
  
  export const archiveFAQRequest = () => ({ type: ARCHIVE_FAQ_REQUEST });
  export const archiveFAQSuccess = (faqId) => ({
    type: ARCHIVE_FAQ_SUCCESS,
    payload: faqId,
  });
  export const archiveFAQFailure = (error) => ({
    type: ARCHIVE_FAQ_FAILURE,
    payload: error,
  });
  
  // Thunks to handle FAQ-related actions
  
  export const fetchFAQsAction = (archived = false) => async (dispatch) => {
    dispatch(fetchFAQsRequest());
    try {
      const response = await fetchFAQs(archived);
  
      if (response.success) {
        dispatch(fetchFAQsSuccess(response.data));
      } else {
        dispatch(fetchFAQsFailure(response.error));
      }
    } catch (error) {
      dispatch(fetchFAQsFailure(error.message || "Failed to fetch FAQs"));
    }
  };
  
  export const createFAQAction = (question, answer) => async (dispatch) => {
    dispatch(createFAQRequest());
    try {
      const response = await createFAQ(question, answer);
  
      if (response.success) {
        dispatch(createFAQSuccess(response.data));
      } else {
        dispatch(createFAQFailure(response.error));
      }
    } catch (error) {
      dispatch(createFAQFailure(error.message || "Failed to create FAQ"));
    }
  };
  
  export const updateFAQAction = (faqId, question, answer) => async (dispatch) => {
    dispatch(updateFAQRequest());
    try {
      const response = await updateFAQ(faqId, question, answer);
  
      if (response.success) {
        dispatch(updateFAQSuccess(response.data));
      } else {
        dispatch(updateFAQFailure(response.error));
      }
    } catch (error) {
      dispatch(updateFAQFailure(error.message || "Failed to update FAQ"));
    }
  };
  
  export const archiveFAQAction = (faqId) => async (dispatch) => {
    dispatch(archiveFAQRequest());
    try {
      const response = await archiveFAQ(faqId);
  
      if (response.success) {
        dispatch(archiveFAQSuccess(faqId));
      } else {
        dispatch(archiveFAQFailure(response.error));
      }
    } catch (error) {
      dispatch(archiveFAQFailure(error.message || "Failed to archive FAQ"));
    }
  };
  